"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getHouseholdSize;

function getHouseholdSize(dataStore) {
  var familySize = 1;
  if (dataStore.married === true && dataStore.separateHouseholds === false) familySize += 1;

  if (dataStore.household.dependents && dataStore.household.dependents.length > 0) {
    familySize += dataStore.household.dependents.filter(function (d) {
      return d.livesWithDebtor === true;
    }).length;
  }

  return familySize;
}